import React from 'react'
import { useNavigate } from 'react-router'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'
import { triggerNonBlockingCognitoContactSync } from '../Services/mfaService'
import { SettingsItemWithIcon } from '../../Common/SettingItem/SettingItem'

export const MFASettingsRow: React.FC = () => {
  const navigate = useNavigate()
  const { accountNumber } = useAuthenticatedAccount()

  const handleClick = () => {
    triggerNonBlockingCognitoContactSync(accountNumber)
    navigate('/account/settings/mfa/')
  }

  return (
    <SettingsItemWithIcon
      label='Multi-factor Authentication (MFA)'
      iconName='LineShield01'
      onClick={handleClick}
    />
  )
}
